<div class="donut-card clickable" (click)="openFileService()">
  <header class="card-head">
    <h3>File Status Breakdown</h3>
    <p>Distribution of all {{ total() | number }} files</p>
  </header>

  <ng-container *ngIf="!isLoading && total() > 0">
    <div class="donut-wrap">
      <svg width="170" height="170" viewBox="0 0 170 170">
        <!-- Background ring -->
        <circle cx="85" cy="85" r="62" stroke="#1E1F2B" stroke-width="22" fill="none"/>
        <!-- Segments -->
        <circle *ngFor="let seg of segments()"
                cx="85" cy="85" r="62"
                fill="none"
                stroke-width="22"
                [attr.stroke]="seg.color"
                [attr.stroke-dasharray]="seg.dasharray"
                [attr.stroke-dashoffset]="seg.dashoffset"
                transform="rotate(-90 85 85)"
                stroke-linecap="butt"/>
      </svg>
      <div class="donut-center">
        <div class="center-num">{{ total() | number }}</div>
        <div class="center-label">TOTAL FILES</div>
      </div>
    </div>

    <div class="legend">
      <div class="legend-row" *ngFor="let seg of segments()">
        <div class="legend-left">
          <span class="dot" [style.background]="seg.color"></span>
          <span class="label">{{ seg.label }}</span>
        </div>
        <span class="value">{{ seg.count | number }} · {{ seg.pct }}%</span>
      </div>
    </div>
  </ng-container>

  <div class="empty-state" *ngIf="!isLoading && total() === 0">
    <i class="bi bi-pie-chart"></i>
    <p>No files in this period</p>
  </div>

  <div class="loading-state" *ngIf="isLoading">
    <div class="donut-skeleton"></div>
    <div class="legend-skeleton">
      <div class="legend-skel" *ngFor="let _ of [1,2,3,4]"></div>
    </div>
  </div>
</div>
